import "../../fonts/fonts.css";
import "./header.css";
import "../../assets/css_variables.css";
import React, { useRef, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import RoutesToPages from "../../RoutesToPages";
import cn from "classnames";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const headerRef = useRef(null);
  const navRef = useRef(null);
  const counterRef = useRef(null);
  const backButtonRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const pathName = location.pathname;

  useEffect(() => {
    const body = document.body;

    if (isOpen) {
      body.style.overflow = "hidden";
      const userHash = localStorage.getItem("userHash");
      let userData = JSON.parse(localStorage.getItem(userHash));
      const maxAttempts = localStorage.getItem("max_attempts");
      const usedAttempt = localStorage.getItem("generated_recipe_today");

      counterRef.current.textContent = usedAttempt + "/" + maxAttempts;
    } else {
      body.style.overflow = "";
    }
    // Cleanup effect on component unmount
    return () => {
      body.style.overflow = "";
    };
  }, [isOpen]);

  useEffect(() => {
    if (
      pathName === RoutesToPages.loginPage ||
      pathName === RoutesToPages.terms
    ) {
      headerRef.current.classList.add("hide");
    } else {
      headerRef.current.classList.remove("hide");
    }

    if ((isOpen || isOpen === false) && pathName === RoutesToPages.home) {
      backButtonRef.current.classList.add("back-button__hidden");
    } else if (isOpen) {
      backButtonRef.current.classList.add("back-button__hidden");
    } else {
      backButtonRef.current.classList.remove("back-button__hidden");
    }
  }, [pathName, isOpen]);

  const userHash = localStorage.getItem("userHash");

  useEffect(() => {
    // if (!userHash) {
    //   navigate(RoutesToPages.loginPage);
    // } else {
    const arrayRoutes = Object.entries(RoutesToPages).map(
      ([key, value]) => value
    );

    if (!arrayRoutes.includes(pathName)) {
      if (
        !pathName.startsWith("/single-recipe") ||
        pathName.endsWith("/single-recipe/")
      ) {
        navigate(RoutesToPages.home);
      }
    }
    //}
  }, [pathName]);

  const menuBtn = cn("menu__btn", {
    menu__btn_active: isOpen,
  });

  const menuNav = cn("menu__nav", {
    menu__nav_active: isOpen,
  });

  const headerHeight = () => {
    return headerRef.current.offsetHeight;
  };

  const handleMenuVisibility = () => {
    setIsOpen(!isOpen);
    navRef.current.style.top = headerHeight() + 1 + "px";
  };

  const menuRedirect = ({ target }) => {
    setIsOpen(!isOpen);
    const URL = target.dataset.href;
    navigate(URL);
  };

  const navigatePreviousPage = () => {
    setIsOpen(false);
    navigate(-1);
  };

  const handleHomeNavigate = () => {
    if (pathName === RoutesToPages.home) {
      backButtonRef.current.classList.add("back-button__hidden");
      return;
    }
    setIsOpen(false);
    navigate(RoutesToPages.home);
  };

  return (
    <header
      ref={headerRef}
      id="header__wrapper"
      className="header__wrapper hide"
    >
      <div className="header">
        <div ref={backButtonRef} className="button__back_wrapper">
          <button
            className="button_back"
            onClick={navigatePreviousPage}
          ></button>
        </div>
        <div className="logo__wrapper">
          <img
            className="logo"
            onClick={handleHomeNavigate}
            src={require("./img/logo_mini.png")}
            alt="main logo"
          />
        </div>
        <menu>
          <div onClick={handleMenuVisibility} className={menuBtn}>
            <span></span>
          </div>

          <nav onClick={menuRedirect} ref={navRef} className={menuNav}>
            <h2 className="menu__title">Menu</h2>
            <div id="menu__block" className="menu__block">
              <button
                data-href={RoutesToPages.home}
                className="menu__item menu__item_home"
              >
                <span
                  data-href={RoutesToPages.home}
                  className="menu__item_icon"
                >
                  <img src={require("./img/home.png")} alt="icon home" />
                </span>
                <span data-href={RoutesToPages.home}>Strona główna</span>
              </button>

              <button
                data-href={RoutesToPages.favourites}
                className="menu__item menu__item_favourites"
              >
                <span
                  data-href={RoutesToPages.favourites}
                  className="menu__item_icon"
                >
                  <img
                    src={require("./img/favourites.png")}
                    alt="icon favourites"
                  />
                </span>
                <span data-href={RoutesToPages.favourites}>
                  Ulubione przepisy
                </span>
              </button>

              <button
                data-href={RoutesToPages.terms}
                className="menu__item menu__item_terms"
              >
                <span
                  data-href={RoutesToPages.terms}
                  className="menu__item_icon"
                >
                  <img src={require("./img/terms.png")} alt="icon terms" />
                </span>
                <span data-href={RoutesToPages.terms}>Regulamin</span>
              </button>

              <button
                data-href={RoutesToPages.contact}
                className="menu__item menu__item_contact"
              >
                <span
                  data-href={RoutesToPages.contact}
                  className="menu__item_icon"
                >
                  <img src={require("./img/postbox.png")} alt="icon postbox" />
                </span>
                <span data-href={RoutesToPages.contact}>Kontakt z nami</span>
              </button>
              <div className="attempts__counter">
                Dzisiaj podjęto prób generowania:{" "}
                <strong ref={counterRef}> 4/5</strong>
              </div>
            </div>
          </nav>
        </menu>
      </div>
    </header>
  );
};

export default Header;
